import React from "react";
import { Helmet } from "react-helmet";
import "../css/TermsConditions.css";

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Garud Cab Service | Terms & Conditions</title>
        <meta
          name="description"
          content="Terms & Conditions for Garud Cab Service including local rides, airport transfers, outstation trips, rentals, and corporate travel."
        />
      </Helmet>

      {/* Banner */}

      <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Terms & Conditions
        </h2>
      </div>
    </section>
    

      {/* Terms Section */}
      <section className="terms-section">
        <div className="container">
          <div className="row g-0">

            <img
              src="/images/term.jpg"
              alt="Garud Cab Service Terms and Conditions"
            />

            <div className="col-md-12">
              <div className="terms-content">

                <p>
                  <b className="highlight">1. Booking Confirmation:</b>
                  <br />
                  All bookings made with Garud Cab Service are subject to
                  vehicle availability. A booking will be considered confirmed
                  only after confirmation from our booking team or booking
                  system.
                </p>

                <p>
                  <b className="highlight">2. Cab Service Usage:</b>
                  <br />
                  Garud Cab Service provides safe, comfortable, and reliable
                  passenger transportation services. Carrying illegal,
                  dangerous, hazardous, or restricted items inside the vehicle
                  is strictly prohibited.
                </p>

                <p>
                  <b className="highlight">3. Payment Terms:</b>
                  <br />
                  Customers can make payments through cash, UPI, cards, online
                  payment, or other payment methods made available by Garud
                  Cab Service. Advance payment may be required for selected
                  bookings.
                </p>

                <p>
                  <b className="highlight">4. Cancellation Policy:</b>
                  <br />
                  Customers are requested to cancel their bookings as early as
                  possible. Cancellation charges may apply depending on the
                  booking category, vehicle type, and cancellation timing.
                </p>

                <p>
                  <b className="highlight">5. Customer Information:</b>
                  <br />
                  Customers are responsible for providing accurate pickup
                  location, destination, travel date, passenger details, and
                  contact information at the time of booking.
                </p>

                <p>
                  <b className="highlight">6. Passenger & Luggage Policy:</b>
                  <br />
                  Passengers must follow the seating capacity of the assigned
                  vehicle. Customers should inform Garud Cab Service in
                  advance if they are carrying additional or oversized
                  luggage.
                </p>

                <p>
                  <b className="highlight">7. Driver & Travel Regulations:</b>
                  <br />
                  Garud Cab Service drivers follow applicable traffic,
                  transportation, and safety regulations. Additional charges
                  may apply for extended travel duration, route changes, or
                  additional stops.
                </p>

                <p>
                  <b className="highlight">8. Safety Rules:</b>
                  <br />
                  Passengers must follow all safety instructions provided by
                  the driver and maintain appropriate behavior throughout the
                  journey. Seat belts should be used wherever provided.
                </p>

                <p>
                  <b className="highlight">9. Service Refusal:</b>
                  <br />
                  Garud Cab Service reserves the right to refuse or terminate
                  a journey in cases involving unsafe conditions, abusive
                  behavior, illegal activities, or violation of applicable
                  laws.
                </p>

                <p>
                  <b className="highlight">10. Fare Changes:</b>
                  <br />
                  The final fare may vary based on toll charges, parking fees,
                  waiting time, route changes, additional stops, state taxes,
                  or other additional travel requirements.
                </p>

                <p>
                  <b className="highlight">11. Legal Jurisdiction:</b>
                  <br />
                  Any dispute relating to Garud Cab Service shall be handled
                  according to applicable laws and the appropriate jurisdiction.
                </p>

                <h3>Rental Policy</h3>

                <p>
                  <b className="highlight">Services Available:</b>
                  <br />
                  Garud Cab Service offers local cab services, airport
                  transfers, outstation trips, one-way trips, round trips,
                  corporate transportation, rental services, and customized
                  travel solutions.
                </p>

                <p>
                  <b className="highlight">Vehicle Availability:</b>
                  <br />
                  Vehicle allocation depends on availability at the time of
                  booking. Garud Cab Service may provide an equivalent or
                  upgraded vehicle when necessary, subject to availability.
                </p>

                <p>
                  <b className="highlight">
                    Toll, Parking & Additional Charges:
                  </b>
                  <br />
                  Toll fees, parking charges, state taxes, entry fees, and
                  other applicable charges will be payable by the customer
                  unless specifically included in the selected package.
                </p>

                <p>
                  <b className="highlight">Night Travel Charges:</b>
                  <br />
                  Additional charges may apply to trips scheduled during
                  specified late-night or early-morning hours, depending on
                  the booking type.
                </p>

                <p>
                  <b className="highlight">Extra Usage:</b>
                  <br />
                  Additional charges may apply if the customer exceeds the
                  agreed rental duration, distance limit, or number of included
                  stops.
                </p>

                <h3>Refund Policy</h3>

                <p>
                  <b className="highlight">Refund Eligibility:</b>
                  <br />
                  Refund requests will be reviewed based on cancellation
                  timing, booking category, payment status, and the applicable
                  cancellation policy.
                </p>

                <p>
                  <b className="highlight">Refund Processing:</b>
                  <br />
                  Approved refunds will generally be processed within 5–7
                  working days. The actual time taken may vary depending on
                  the customer's bank or payment provider.
                </p>

                <p>
                  <b className="highlight">Non-Refundable Amounts:</b>
                  <br />
                  Certain service charges, convenience fees, advance booking
                  charges, or promotional offers may not be eligible for a
                  refund.
                </p>

                <p>
                  <b className="highlight">No-Show Policy:</b>
                  <br />
                  Customers who fail to appear at the agreed pickup location
                  within the applicable waiting period may be treated as a
                  no-show and may not be eligible for a refund.
                </p>

                <p>
                  <b className="highlight">Waiting Charges:</b>
                  <br />
                  Additional waiting charges may apply when the customer
                  requests the driver to wait beyond the complimentary waiting
                  period provided with the booking.
                </p>

                <h3>Customer Responsibilities</h3>

                <p>
                  <b className="highlight">Accurate Booking Details:</b>
                  <br />
                  Customers must provide correct travel dates, pickup
                  locations, destinations, passenger information, and contact
                  details while making a booking.
                </p>

                <p>
                  <b className="highlight">Vehicle Care:</b>
                  <br />
                  Customers are expected to maintain reasonable care of the
                  vehicle during the journey. Any damage caused by intentional
                  or negligent behavior may be subject to applicable charges.
                </p>

                <p>
                  <b className="highlight">Prohibited Activities:</b>
                  <br />
                  Smoking, carrying illegal substances, transporting hazardous
                  materials, or engaging in unlawful activities inside the
                  vehicle is strictly prohibited.
                </p>

                <h3>Service Availability</h3>

                <p>
                  <b className="highlight">Unforeseen Circumstances:</b>
                  <br />
                  Garud Cab Service will make reasonable efforts to provide
                  the booked service. However, delays or changes may occur due
                  to traffic, weather conditions, road closures, vehicle
                  breakdowns, government restrictions, or other circumstances
                  beyond our reasonable control.
                </p>

              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Garud Cab Service</h2>

            <p>
              For booking assistance, cancellation requests, or customer
              support, please contact Garud Cab Service:
            </p>

              <ul>
              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+919970007784">
                  +91 9970007784
                </a>
              </li>

              <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@garudcabs.com">
                  booking@garudcabs.com
                </a>
              </li>

              <li>
                <b>Address:</b>
                <br />

                <h6>Garud Cab Service</h6>

               
                 Office No.101 Anand Heights<br/>
                 Chandan Nagar, Kharadi, Pune,<br/>
                 Maharashtra, India-  411014
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;